"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { ssoEnabled, ssoLoginRedirect } from "../lib/api/sso";

export default function RootPage() {
  const router = useRouter();

  useEffect(() => {
    // 루트 접속 시 로그인 상태에 따라 리다이렉트
    const token = typeof window !== "undefined"
      ? localStorage.getItem("access_token")
      : null;

    if (token) {
      router.replace("/home");
    } else {
      if (ssoEnabled()) {
        ssoLoginRedirect("/home");
      } else {
        router.replace("/login");
      }
    }
  }, [router]);

  return (
    <div className="flex items-center justify-center min-h-[100dvh] bg-[#020617]">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
    </div>
  );
}
